import React from 'react'
import './index.css'
import logUtil from 'utils/log'
import Flex from 'components/Flex'
import getByUseItWithVariantIdsProductSelector from 'modules/product/redux/selectors/get-by-perfect-your-look-variant-ids'
import useSelector from 'hooks/use-selector'
import QuickShopProductSidebarUseItWithProductSwatchPickerItem from 'containers/QuickShopProductSidebar/components/UseItWith/components/Product/SwatchPicker/Item'
import getSelectedUseItWithVariantIdProductSelect from 'modules/product/redux/selectors/get-selected-perfect-your-look-variant-id'
import getSelectedVariantSelect from 'modules/variant/redux/selectors/get-selected-variant'
import updateSelectedUseItWithVariantIdProductAction from 'modules/product/redux/actions/update-selected-perfect-your-look-variant-id'
import useDispatch from 'hooks/use-dispatch'
import QuickShopProductSidebarUseItWithProductSwatchPickerAutoSelect from 'containers/QuickShopProductSidebar/components/UseItWith/components/Product/SwatchPicker/AutoSelect'

/**
 * @param props
 * @param {number[]} props.perfectYourLookVariantIds
 * @param {string} props.analyticEventPrefix
 * @returns {JSX.Element}
 * @constructor
 */
export default function QuickShopProductSidebarUseItWithProductSwatchPicker (props) {
  const {
    perfectYourLookVariantIds,
    analyticEventPrefix
  } = props
  const selectedUseItWithVariantId = useSelector(
    getSelectedUseItWithVariantIdProductSelect
  )
  const dispatch = useDispatch()

  /**
   * @type {ProductVariantCollection[]}
   */
  const perfectYourLookVariants = useSelector(
    getByUseItWithVariantIdsProductSelector(perfectYourLookVariantIds)
  )

  /**
   * @type {ProductVariantCollection}
   */
  const selectedVariant = useSelector(getSelectedVariantSelect)
  const debugProps = {
    props,
    selectedVariant,
    selectedUseItWithVariantId
  }
  logUtil('QuickShopProductSidebarUseItWithProductSwatchPicker').debug('debugProps=', debugProps)

  React.useEffect(() => {
    if (!selectedVariant?.pyl_variant_id) {
      return
    }

    dispatch(
      updateSelectedUseItWithVariantIdProductAction(
        selectedVariant.pyl_variant_id
      )
    )
  }, [selectedVariant])

  return (
    <Flex
      className='quick-shop-product-sidebar-perfect-your-look-product-swatch-picker'
    >
      <QuickShopProductSidebarUseItWithProductSwatchPickerAutoSelect />

      {
        perfectYourLookVariants.map(perfectYourLookVariantItem => {
          return (
            <QuickShopProductSidebarUseItWithProductSwatchPickerItem
              key={perfectYourLookVariantItem.variant_id}
              isSelected={perfectYourLookVariantItem.variant_id === selectedUseItWithVariantId}
              perfectYourLookVariantItem={perfectYourLookVariantItem}
              analyticEventPrefix={analyticEventPrefix}
            />
          )
        })
      }
    </Flex>
  )
}
